///---------------------------------------------------------------------------
//! Copyright (C) ASQUARED SRL - All Rights Reserved
//* Unauthorized copying of this file, via any medium is strictly prohibited
//* Proprietary and confidential
//* Written by Alexandru Gârbacea <g99.alex@yahoo.com>, September 2022
//? @author g99.alex@yahoo.com
///---------------------------------------------------------------------------

import React, {useState} from 'react'
import { createPortal } from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faLock } from '@fortawesome/free-solid-svg-icons'
import { createNotification } from '../services/NotificationService'

const Popup = ({data, close, children}) => {

    const {title, text, type, func} = data

    const [valStatArr, setValStatArr] = useState(type === 1 ? data.valStatArr : [])

    const handleValStatSave = async (action) => {
        action ? func(valStatArr) : setValStatArr(data.valStatArr)
        close()
    }

    const OUTSIDE_ID = 'modal-popup-wrapper-bg'

    const handleOutsideClick = (id) => {
        if(id === OUTSIDE_ID) close()
    }

    const [acknowledgeErrors, setAcknowledgeErrors] = useState(false)

    const [formData, setFormData] = useState(type === 2 ? {
        cName:  data.comp.cif,
        reprez: data.uData.name,
        pos:    'Reprezentant',
        mail:   data.uData.email,
        phone:  data.uData.phone,
        tName:  data.uData.cui,
        linesLeft: data.linesLeft
    } : {})

    const returnContent = () => {
        switch(type) {
            // sure exit?
            case 0: {
                return(
                    <>
                    <div className='md-body'>
                        <div className='md-confirm__text'>{text}</div>
                    </div>
                    <div className='md-footer md-footer--center'>
                        <button className='md-btn md-btn--ghost' onClick={() => func(false)}>Nu</button>
                        <button className='md-btn md-btn--primary' onClick={() => func(true)}>Da</button>
                    </div>
                    </>
                )
            }
            // val stat
            case 1: {
                const tableHeaders = [
                    'Cond. livrare',
                    'Mod transport',
                    'Nat. tranzacție',
                    'Țara',
                    'Semn',
                    'Procent(%)'
                ]

                const handleChange = (val, bigI, smallI) => {
                    let toChange = valStatArr
                    toChange[bigI][smallI] = val.toString() === '' ? 0 : val.toString()
                    setValStatArr(toChange)
                }

                return(
                    <>
                    <div className='md-body'>
                        <div className='md-table-wrap'>
                            <div className='res-table-section'>
                                <div className='res-table-row header-cell'>
                                    {
                                        tableHeaders.map((value, index) => {
                                            return(
                                            <input type="text" key={`${value} - ${index}`}
                                                disabled={true}
                                                readOnly={true}
                                                defaultValue = {value}
                                                className = 'res-table-input'
                                                style={{width:`8rem`}}
                                            />
                                            )
                                        })
                                    }
                                </div>
                                {
                                valStatArr.map((value, index) => {
                                    return(
                                        <div className='res-table-row rows'
                                        key={`${value} - ${index}`}>
                                            {
                                                value.map((val, i) => {
                                                    if(i < 4) {
                                                        return(
                                                        <input type='text'
                                                            key={`${val} - ${i} - ${index}`}
                                                            defaultValue={val}
                                                            disabled={true}
                                                            readOnly={true}
                                                            className={`res-table-input`}
                                                            style={{width: `8rem`}}
                                                        />
                                                        )
                                                    }
                                                    // sign
                                                    else if(i === 4) {
                                                        return(
                                                        <select className='res-table-input'
                                                        key={`${val} - ${i} - ${index}`}
                                                        style={{width: `10.1rem`}} defaultValue={val}
                                                        onChange={e => handleChange(e.target.value, index, i)}>
                                                            <option value={'PLUS'}>{'PLUS'}</option>
                                                            <option value={'MINUS'}>{'MINUS'}</option>
                                                        </select>
                                                        )
                                                    }
                                                    // procent
                                                    else {
                                                        return(
                                                        <input type='number' step={'0.0001'}
                                                            key={`${val} - ${i} - ${index}`}
                                                            defaultValue={parseFloat(val)}
                                                            onBlur={e => handleChange(e.target.value, index, i)}
                                                            className={`res-table-input`}
                                                            style={{width: `8rem`}}
                                                        />
                                                        )
                                                    }
                                                })
                                            }
                                        </div>
                                    )
                                })
                                }
                            </div>
                        </div>
                    </div>
                    <div className='md-footer'>
                        <button className='md-btn md-btn--ghost'
                        onClick={() => handleValStatSave(false)}>Anulează</button>
                        <button className='md-btn md-btn--primary'
                        onClick={() => handleValStatSave(true)}>Calculează</button>
                    </div>
                    </>
                )
            }
            // generate XML
            case 2: {
                const {
                    tert, hasValStat, linesLeft, linesToGenerate, hasErr, exists,
                    hasWarn = false,
                    errorCount = 0,
                    warningCount = 0,
                    findings = [],
                    findingsTotal = 0,
                } = data

                //? Why generation cannot run right now - empty means it can.
                //? Drives the footer note, the button style and the click message, so the
                //? three can never say different things.
                const blockReason = hasErr
                    ? `Fișierul nu poate fi generat: ${errorCount} ${errorCount === 1 ? 'eroare' : 'erori'} ` +
                      `${errorCount === 1 ? 'trebuie corectată' : 'trebuie corectate'} în tabel. ` +
                      `Aplicația oficială INTRASTAT ar respinge declarația.`
                    : (hasWarn && !acknowledgeErrors)
                        ? 'Bifați că ați verificat avertismentele pentru a putea genera.'
                        : ''

                return(
                    <>
                    <div className='md-body'>
                        <div className='ap-popup' style={{textAlign:"left"}}>
                            {!hasValStat &&
                                <div className='ap-popup-warning'>
                                    Nu uitați să selectați "Calcul valoare statistică" în cazul în care aveți nevoie de acesta.
                                </div>
                            }

                            <div className='ap-popup-field'>
                                <label className='ap-popup-label' htmlFor='genFirma'>Firmă</label>
                                <input className='input-text' type='text' id='genFirma'
                                    disabled={true}
                                    readOnly={true}
                                    defaultValue={formData.cName} required/>
                            </div>

                            <div className='ap-popup-field'>
                                <label className='ap-popup-label' htmlFor='genContact'>Persoană de contact</label>
                                <input className='input-text' type='text' id='genContact'
                                    value={formData.reprez}
                                    onChange={(e) => setFormData(prev => ({...prev, reprez:e.target.value}))} required/>
                            </div>

                            <div className='ap-popup-field'>
                                <label className='ap-popup-label' htmlFor='genPoz'>Poziție</label>
                                <input className='input-text' type='text' id='genPoz'
                                    value={formData.pos}
                                    onChange={(e) => setFormData(prev => ({...prev, pos:e.target.value}))} required/>
                            </div>

                            <div className='ap-popup-field'>
                                <label className='ap-popup-label' htmlFor='genEmail'>Email</label>
                                <input className='input-text' type='email' id='genEmail'
                                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                                    value={formData.mail}
                                    onChange={(e) => setFormData(prev => ({...prev, mail:e.target.value}))} required/>
                            </div>

                            <div className='ap-popup-field'>
                                <label className='ap-popup-label' htmlFor='genPhone'>Telefon</label>
                                <input className='input-text' type='tel' pattern="[0-9]{10,12}" id='genPhone'
                                    value={formData.phone}
                                    onChange={(e) => setFormData(prev => ({...prev, phone:e.target.value}))} required/>
                            </div>

                            {tert &&
                                <div className='ap-popup-field'>
                                    <label className='ap-popup-label' htmlFor='genTert'>Declarant terț</label>
                                    <input className='input-text' type='text' id='genTert'
                                        disabled={true}
                                        readOnly={true}
                                        defaultValue={formData.tName} />
                                </div>
                            }

                            <div className='ap-popup-divider'></div>

                            {!exists ? (
                                <div className='ap-popup-info'>
                                    <div>Vor fi folosite <b>{linesToGenerate}</b> linii din abonament.</div>
                                    <div>Vă vor rămâne <b>{linesLeft}</b> linii în această lună pentru abonamentul actual.</div>
                                </div>
                            ) : (
                                <div className='ap-popup-info' style={{alignItems:'center'}}>
                                    <div>Există deja un fișier generat. Îl puteți descărca aici:</div>
                                    <button className='md-btn md-btn--primary'
                                        onClick={() => func(2, formData, data.generatedArr)}>Descarcă
                                    </button>
                                </div>
                            )}

                            {(hasErr || hasWarn) && (
                                <div className={`ap-popup-warning${hasErr ? ' ap-popup-warning--error' : ''}`}>
                                    {hasErr ? (
                                        <>
                                        <div><b>
                                            Fișierul conține {errorCount} {errorCount === 1 ? 'eroare' : 'erori'} care
                                            ar fi respinse de aplicația oficială INTRASTAT. Generarea este blocată.
                                        </b></div>
                                        <div>
                                            Corectați valorile marcate cu roșu în tabel (sau bifați
                                            'Afișează doar erori' pentru a le filtra), apoi generați din nou.
                                        </div>
                                        </>
                                    ) : (
                                        <div><b>
                                            Fișierul conține {warningCount} {warningCount === 1 ? 'avertisment' : 'avertismente'}.
                                            Fișierul rămâne valid, dar verificați datele.
                                        </b></div>
                                    )}

                                    {findings.length > 0 && (
                                        <div className='popup-error-wrapper' style={{marginTop:'8px', maxHeight:'220px', overflowY:'auto'}}>
                                            {findings.map((finding, index) => (
                                                <div
                                                    className={`popup-error-row${finding.severity === 'warning' ? ' popup-error-row--warning' : ''}`}
                                                    key={`gen-finding-${index}`}
                                                >
                                                    {finding.row !== undefined && <><b>Linia {finding.row}</b> - </>}
                                                    <b>{finding.label}</b>: {finding.message}
                                                </div>
                                            ))}
                                            {findingsTotal > findings.length && (
                                                <div className='popup-error-row'>
                                                    <i>... și încă {findingsTotal - findings.length}.</i>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {!hasErr && hasWarn && (
                                        <label style={{display:'flex', alignItems:'center', gap:'8px', marginTop:'8px', cursor:'pointer', fontWeight:'normal'}}>
                                            <input
                                                type='checkbox'
                                                checked={acknowledgeErrors}
                                                onChange={(e) => setAcknowledgeErrors(e.target.checked)}
                                            />
                                            Am verificat avertismentele de mai sus.
                                        </label>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className='md-footer'>
                        {blockReason !== '' &&
                            <span className='md-footer__note'>
                                <FontAwesomeIcon icon={faLock} /> {blockReason}
                            </span>
                        }
                        <button className='md-btn md-btn--ghost' onClick={() => func(false)}>Anulare</button>
                        {/* Deliberately not `disabled`: a dead button gives the user no reason,
                            so it stays clickable and explains itself instead. */}
                        <button
                            className={`md-btn md-btn--primary${blockReason !== '' ? ' md-btn--blocked' : ''}`}
                            title={blockReason}
                            onClick={() => {
                                if (blockReason !== '') {
                                    createNotification('error', blockReason)
                                    return
                                }
                                func(1, formData, data.generatedArr)
                            }}>
                            {blockReason !== '' && <><FontAwesomeIcon icon={faLock} />{' '}</>}
                            {exists ? 'Generează din nou' : 'Generează'}
                        </button>
                    </div>
                    </>
                )
            }
            default:
                break
        }
    }

    // Determine modal size based on type
    const sizeClass = type === 1 ? 'md-modal--xl' : type === 0 ? 'md-modal--sm' : ''

    //? Rendered into <body> instead of in place: the popup lives inside .handle-section,
    //? which keeps a transform after its fadeSlideUp animation, and any transform other
    //? than none makes an element the containing block of its position:fixed descendants.
    //? In place, the overlay centred itself on the table card instead of the viewport.
    return createPortal(
        <div className='md-overlay' id={OUTSIDE_ID} onClick={(e) => handleOutsideClick(e.target.id)}>
            <div className={`md-modal ${sizeClass}`}>
                <div className='md-header'>
                    <h2 className='md-header__title'>{title}</h2>
                    <button className='md-header__close' onClick={() => close()}>
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                </div>
                {type !== 3 ? returnContent() : (
                    <div className='md-body'>
                        {children}
                    </div>
                )}
            </div>
        </div>,
        document.body
    )
}

export default Popup
